import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TraduccionesComponent } from '../../../Alsa-MA-Angular-utils/src/app/traducciones.component';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;
declare var GetStopsFromCity: any;
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos


/*--------------------------------------------- Variables Globales ---------------------------------------------*/
declare var stops: any; // Las paradas a poner en el maps

declare function initMap(): any;

@Component({
    selector: 'app-near-by',
    templateUrl: './near-by.component.html',
    styleUrls: ['./near-by.component.css']
})
export class AppComponent implements OnInit {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = TraduccionesComponent.arrayTraducciones;
    jsonData;
    paradas = []; paradasCompleto = [];
    mapClass = ''; errorClass = 'invisible'; errorSpinnerClass = '';
    generalContainerClass = "invisible";
    showRouteListClass = '';
    showStopsClass = 'invisible';

    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    leerDatos(): Observable<Response> {
        const body = 'cityId=' + idCiudadLiferay;
        const httpOptions = { 
            headers: new HttpHeaders({ 
                'Content-Type': 'application/x-www-form-urlencoded',
            })
        };
        return this.http.post(GetStopsFromCity, body, httpOptions);
    }

    public recogerParadas() {
        this.leerDatos().subscribe(res => this.jsonData = res, (err) => console.error(err), () => this.poblarParadas());
    }

    public poblarParadas() {
        this.paradas = this.jsonData.stops;
        stops = this.paradas;

        // Tras cargar las paradas inicializo el mapa
        if (typeof stops !== 'undefined') {
            initMap();
            this.generalContainerClass = "";
        } else {
            this.errorClass = '';
            this.errorSpinnerClass = 'invisible';
        }
    }

    public setTraducciones() {
        if (typeof i18nVS !== 'undefined') { // Para saber si Liferay esta disponible o no
            this.i18nL = i18nVS;
        } else { // si no estamos en Liferay se cargan nuestras clases
            this.mapClass = 'mapClass';
        }
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.recogerParadas();
        this.setTraducciones();
    }

    onShowStops(): void {
        this.showRouteListClass = 'invisible';
        this.showStopsClass = '';
    }

    onHideStops(): void {
        this.showRouteListClass = '';
        this.showStopsClass = 'invisible';
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(@Inject(HttpClient) private http) { }

}



// WEBPACK FOOTER //
// ./src/app/near-by.component.ts